/*
  FC Links With Carousel
  - Collapsible category sidebar (hamburger toggle)
  - Auto-scrolling, scroll-snap carousel with dot navigation
  Vanilla JS, no dependencies. Respects prefers-reduced-motion.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSidebar(root) {
    var sidebar = root.querySelector('.fc-lwc__sidebar');
    var toggle = root.querySelector('.fc-lwc__toggle');
    if (!sidebar || !toggle) return;

    toggle.addEventListener('click', function () {
      var collapsed = sidebar.getAttribute('data-collapsed') === 'true';
      sidebar.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('.fc-lwc__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.fc-lwc__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.fc-lwc__dot'));
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var speed = (parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6) * 1000;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActiveDot(current);
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function start() {
      if (!autoplay || timer) return;
      timer = window.setInterval(function () {
        goTo(current + 1);
      }, speed);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stop();
        goTo(i);
        start();
      });
    });

    // Arrow navigation
    var prevBtn = root.querySelector('.fc-lwc__arrow--prev');
    var nextBtn = root.querySelector('.fc-lwc__arrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stop();
        goTo(current - 1);
        start();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stop();
        goTo(current + 1);
        start();
      });
    }

    // Desktop pointer dragging is intentionally disabled — navigation is via the
    // arrows and dots. Touch devices still swipe natively via CSS scroll-snap.

    // Keep the active dot in sync when the user scrolls/swipes manually.
    var scrollDebounce = null;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollDebounce);
      scrollDebounce = window.setTimeout(function () {
        var nearest = Math.round(track.scrollLeft / track.clientWidth);
        if (nearest !== current) {
          current = Math.max(0, Math.min(slides.length - 1, nearest));
          setActiveDot(current);
        }
      }, 100);
    });

    // Pause while the user is interacting or the tab is hidden.
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, stop, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (evt) {
      root.addEventListener(evt, start, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function init() {
    var roots = document.querySelectorAll('[data-fc-lwc]');
    Array.prototype.forEach.call(roots, function (root) {
      initSidebar(root);
      initCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init within the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fc-lwc]');
    if (root) {
      initSidebar(root);
      initCarousel(root);
    }
  });
})();
